import React from 'react';

export interface ChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

export const Chip = React.forwardRef<HTMLButtonElement, ChipProps>(
  ({ active = false, className = '', children, ...props }, ref) => {
    const baseStyles =
      'px-4 py-1.5 rounded-full text-xs font-bold cursor-pointer transition-colors';
    const activeStyles = active
      ? 'bg-primary text-on-primary'
      : 'hover:bg-surface-container-low text-on-surface-variant';

    return (
      <button ref={ref} className={`${baseStyles} ${activeStyles} ${className}`} {...props}>
        {children}
      </button>
    );
  },
);
Chip.displayName = 'Chip';
